<template>
  <material-card color="primary" title="Audit Trail" :text="`${entity} ${entity_id}`" >
    <v-container>
      <v-layout>
        <v-data-table style="width: 100%" fixed-header small density="compact" :loading="loading" hide-default-footer hide-footer :items-per-page='-1'
          :headers="headers" :items="filteredItems" :item-class="itemStyle">
        </v-data-table>
      </v-layout>
    </v-container>
  </material-card>
</template>

<script>
import { getList } from '../../api/base_entity'
import $format from '../../utils/formatter'
//issue 148
import moment from 'moment'
//issue 148
export default {
  props: {
    entity: String,
    entity_id: [String, Number],
    fields: Array,
    filters: Object,
    hideFields: [Array, Object]
  },
  data() {
    return {
      localFilters: { field_name: '', value: '', prev_value: '', account: '', start_date: '', end_date: '' },
      items: [],
      odd: false,
      opened: false,
      loading: false,
      headers: [
        { value: 'action', text: 'Action', width: 120 },
        { value: 'field_name', text: 'Name', width: 150 },
        { value: 'prev_value', text: 'Before', width: 150 },
        { value: 'value', text: 'After', width: 150 },
        { value: 'account', text: 'Account', width: 170, align: 'right' },
        { value: 'datetime', text: 'Date Time', width: 150, align: 'right' },
      ]
    }
  },
  mounted() {
    this._getData()
  },
  computed: {
    filteredItems() {
      return this.items.filter(i => {

        // field name
        if (this.localFilters.field_name && !i?.field_name?.toLocaleLowerCase().includes(this.localFilters.field_name.toLocaleLowerCase())) {
          return false
        }

        // account 
        if (this.localFilters.account && !i?.account?.toLocaleLowerCase().includes(this.localFilters.account.toLocaleLowerCase())) {
          return false
        }

        if (this.localFilters.start_date && i.datetime < this.localFilters.start_date) {
          return false
        }

        if (this.localFilters.end_date && i.datetime > this.localFilters.end_date) {
          return false
        }

        return i
      })
    }
  },
  methods: {
    itemStyle(item) {
      return item.odd ? 'odd' : ''
    },
    _getFieldLabel(field_name) {
      const field = this?.fields?.find(f => f.value === field_name)
      return field?.text ?? $format('field_name', field_name)
    },
    async _getData() {
      let res
      this.loading = true
      if (this.entity_id) {
        res = await getList(`audittrail/${this.entity}/${this.entity_id}`)
      } else {
        res = await getList(`audittrail/${this.entity}`, { filters: this.filters })
      }
      this.items = []
      for (const e of res.data) {
        this.items = this.items.concat(this._getChanges(e))
      }
      //issue 148
      this.items = this.items.filter(x => {
        if (x.field_name.toLowerCase() === 'uuid')
        {
          return false          
        }
        return true
      })
      //issue 148
      
      this.loading = false
    },
    _getChanges(entry) {
      const ignore_fields = ['id', 'restore_pass_token', 'insert_at', 'password']
      let changes = []
      for (const field_name in entry.fields) {

        if (ignore_fields.includes(field_name)) { continue }

        if (this.hideFields && this.hideFields[entry.entity] && this.hideFields[entry.entity].includes(field_name)) {
          continue
        }

        let value
        let prev_value

        // se il campo e' una foreign
        if (entry.foreigns_map[field_name]) {
          value = $format(entry.foreigns_map[field_name], entry.foreigns[entry.foreigns_map[field_name]], 'audit_trail')
          prev_value = $format(entry.foreigns_map[field_name], entry.prev_foreigns[entry.foreigns_map[field_name]], 'audit_trail')
        } else {
          value = $format('field_value', entry.fields[field_name], field_name, 'audit_trail')
          prev_value = $format('field_value', entry.prev_fields[field_name], field_name, 'audit_trail')
        }

        //issue 216
        //issue 217
        if ( typeof(prev_value) === 'object')
        {
          prev_value = JSON.stringify(prev_value)
        }
        if ( typeof(value) === 'object')
        {
          value = JSON.stringify(value)
        }
        //issue 216
        //issue 217

        // se e' un PUT metto solo i valori nuovi
        const isEdit = entry.http_verb === 'PUT' || ['Confirm', 'Request', 'Validate', 'Save New Pdf'].includes(entry.action)

        if (Array.isArray(value) && Array.isArray(prev_value)) {
          const equal = value.length === prev_value.length && value.every((value, index) => value === prev_value[index])
          if (equal) continue
        }
        if (value === prev_value && isEdit) continue

        // non lo metto se entrambi i valori sono vuoti
        if (!value && !prev_value) continue

        //issue delete
        if(entry.action.toLowerCase() === 'delete')
        {
          value = ''
        }
        if(entry.action.toLowerCase() === 'insert')
        {
          prev_value = ''
        }
        //issue delete


        const re = new RegExp(this.entity, 'gi')
        changes.push({
          action: `${entry.action} ${entry.section}`.replace(re, ''), // entry.http_verb,
          account: entry.insert_by,
          odd: this.odd,
          //issue 148
          datetime: moment(entry.insert_at).format('DD-MMM-YYYY HH:mm:ss') ,
          //issue 148
          field_name: this._getFieldLabel(field_name),
          prev_value,
          color: entry.color,
          foreign: entry.entity !== this.entity,
          value
        })
      }

      if (entry.http_verb === 'PUT' && !changes.length) {
        changes.push({
          action: 'EMPTY',
          account: entry.insert_by,
          datetime: (entry.insert_at),
          color: entry.color,
          odd: this.odd,
          field_name: 'EMPTY UPDATE'
        })
      }

      if (changes.length) {
        this.odd = !this.odd
      }
      return changes
    }
  }
}

</script>
<style>
.odd {
  background-color: beige;
}
</style>